import React, { Component } from 'react'
import { SUCCESS } from '../../utils/statusConstants'
import { isEqual } from 'lodash'
import Form from './Form'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'
// import { DndProvider } from 'react-dnd'
// import HTML5Backend from 'react-dnd-html5-backend'
// import TouchBackend from 'react-dnd-touch-backend'
// import MultiBackend, {
//   TouchTransition,
//   MouseTransition,
// } from 'react-dnd-multi-backend'

// const CustomHTML5toTouch = {
//   backends: [
//     {
//       backend: HTML5Backend,
//       transition: MouseTransition,
//       // preview: true,
//       // by default, will dispatch a duplicate `mousedown` event when this backend is activated
//     },
//     {
//       backend: TouchBackend,
//       // Note that you can call your backends with options
//       options: { enableMouseEvents: true },
//       preview: true,
//       transition: TouchTransition,
//     },
//   ],
// }

export default class AddOrEditTaskPage extends Component {
  componentDidMount() {
    const {
      listTemplates,
      // templateLoadStatus,
      // contactLoadStatus,
      getContactsWithEmails,
      // groupLoadStatus,
      getAllGroups,
      // taskTypeLoadStatus,
      listTaskTypes,
      // task,
      // receiveTask,
      taskID,
      modal,
      handleFieldChange,
      changeAutomationType,
      selectCampaign,
      selectStage,
      readTask,
      handleCalendarChange,
      list,
      // campaignLoadStatus,
      location,
      // phonenumbersLoadStatus,
      // read,
      stepperGoTo,
      // selectedActionPrediction,
    } = this.props

    Promise.all([
      new Promise((resolve, reject) =>
        getContactsWithEmails().then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) =>
        getAllGroups().then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) =>
        listTaskTypes().then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) =>
        list('campaign').then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) =>
        list('phonenumbers').then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) =>
        listTemplates().then(payload => resolve(payload)),
      ),
      new Promise((resolve, reject) => {
        if (
          taskID &&
          taskID !== 'new' &&
          taskID?.slice?.(0, 12) !== 'placeholder_'
        ) {
          readTask(taskID).then(payload => resolve(payload))
        } else {
          resolve()
        }
      }),
      new Promise((resolve, reject) => {
        list('sms/template').then(payload => resolve(payload))
      }),
    ]).then(values => {
      console.log(values)
      console.log('hits Promise.all then')

      if (taskID !== 'new' && taskID?.slice?.(0, 12) !== 'placeholder_') {
        this.receiveTaskAndCampaign(values[6])
      } else {
        // console.log('if (taskID === new)')
        if (modal?.taskTypeID) {
          if (modal.stage) {
            stepperGoTo(1, 'task')
          } else {
            stepperGoTo(2, 'task')
          }
        } else {
          stepperGoTo(0, 'task')
        }

        const date =
          location && location.search && location.search.slice(1, 5) === 'date'
            ? location.search.slice(6)
            : null

        Promise.resolve(this.receiveTaskAndCampaign(null, date)).then(() => {
          if (modal) {
            if (modal.taskTypeID) {
              handleFieldChange(
                'selectedActionPrediction',
                taskTypeIDToNameMap[modal.taskTypeID].name,
              )

              if (modal?.name) {
                handleFieldChange('name', modal.name)
              } else if (modal?.campaign?.label) {
                handleFieldChange(
                  'name',
                  `${
                    taskTypeIDToNameMap[modal.taskTypeID].colloquial
                  } for the campaign, '${modal.campaign.label}'`,
                )
              }
            }

            if (modal.stage) {
              Promise.resolve(changeAutomationType('stage'))
                .then(() => selectCampaign(modal.campaign))
                .then(() => selectStage(modal.stage))
            } else if (modal.campaign) {
              Promise.resolve(changeAutomationType('calendar')).then(() =>
                selectCampaign(modal.campaign),
              )
            }

            if (modal.date) {
              const date = new Date()
              date.setTime(modal.date.getTime() + 54000000)
              Promise.resolve(changeAutomationType('calendar')).then(() =>
                handleCalendarChange(date),
              )
            }
          }
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    // console.log('<AddOrEditTaskPage /> componentDidUpdate()')
    if (
      this.props.templateLoadStatus === SUCCESS &&
      this.props.contactLoadStatus === SUCCESS &&
      this.props.groupLoadStatus === SUCCESS &&
      this.props.campaignLoadStatus === SUCCESS &&
      this.props.taskTypeLoadStatus === SUCCESS &&
      this.props.phonenumbersLoadStatus === SUCCESS &&
      !isEqual(this.props.task, prevProps.task)
    ) {
      // console.log('<AddOrEditTaskPage /> componentDidUpdate() hits if')
      this.receiveTaskAndCampaign(this.props.task)
    }
  }

  componentWillUnmount() {
    this.props.receiveTask(null)
    this.props.stepperGoTo(0, 'task')
    this.props.stepperGoTo(0, 'template')
  }

  receiveTaskAndCampaign = (task, date = null) => {
    // console.log('receiveTaskAndCampaign')
    // console.log('task:', task)
    if (task?.task_type_id === '1' || task?.task_type_id === '2') {
      this.props.stepperGoTo(3, 'task')
    } else if (task) {
      this.props.stepperGoTo(2, 'task')
    }

    if (task?.owned_by && task?.owned_by.id) {
      const endpoint = task.owned_by.type === 'S' ? 'campaign/stage' : null
      const stageIDSelected =
        task.owned_by.type === 'S' ? task.owned_by.id : null
      this.props
        .read(task.owned_by.id, 'campaign', endpoint)
        .then(campaign =>
          this.props.receiveTask(task, date, campaign, stageIDSelected),
        )
    } else {
      this.props.receiveTask(task, date)
    }
  }

  render() {
    // const style = this.props.style
    // 	? { ...this.props.style, height: 'calc(100% - 60px)' }
    // 	: { height: 'calc(100% - 60px)' }

    return (
      <div
        className={
          this.props.modal
            ? this.props.classes.contentModal
            : this.props.classes.content
        }
        style={this.props.style}
      >
        <>
          {this.props.task ||
          this.props.taskID === 'new' ||
          this.props.taskID?.slice?.(0, 12) === 'placeholder_' ? (
            <Form modal={this.props.modal} />
          ) : (
            'Loading...'
          )}
        </>
      </div>
    )
  }
}
